import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/system';
import Image1 from '../assets/image1.png';
import Image2 from '../assets/image2.png';
import Image3 from '../assets/image3.png';
import Image4 from '../assets/image4.png';
import Image5 from '../assets/image5.png';


const MarketingCarousel = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 0,
  paddingBottom: '36.25%', // 16:9 aspect ratio
  position: 'relative',
  overflow: 'hidden',
  marginTop: theme.spacing(1),
}));

const CarouselContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  transition: 'transform 0.5s ease',
});

const CarouselSlide = styled(Box)({
  flex: '0 0 100%',
  width: '100%',
  height: '100%',
});

const CarouselImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  backgroundColor: '#f0f0f0',
});

const CarouselButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'rgba(0, 0, 0, 0.5)',
  color: 'white',
  border: 'none',
  padding: theme.spacing(1),
  cursor: 'pointer',
  zIndex: 10,
  minWidth: 'auto',
  '&:hover': {
    background: 'rgba(0, 0, 0, 0.7)',
  },
  '&.prev': { left: 20 },
  '&.next': { right: 20 },
}));

const CarouselIndicators = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(1),
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  zIndex: 10,
}));

const CarouselIndicator = styled(Box)<{ active?: boolean }>(({ theme, active }) => ({
  width: 10,
  height: 10,
  borderRadius: '50%',
  background: active? 'white' : 'rgba(0, 0, 0, 0.5)',
  margin: theme.spacing(0, 0.5),
  cursor: 'pointer',
}));

export const HomeCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <MarketingCarousel>
      <CarouselContainer style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
        {images.map((image, index) => (
          <CarouselSlide key={index}>
            <CarouselImage
              src={image}
              alt={`Marketing Image ${index + 1}`}
              loading="lazy"
            />
          </CarouselSlide>
        ))}
      </CarouselContainer>
      <CarouselButton className="prev" onClick={prevSlide}>&lt;</CarouselButton>
      <CarouselButton className="next" onClick={nextSlide}>&gt;</CarouselButton>
      <CarouselIndicators>
        {images.map((_, index) => (
          <CarouselIndicator
            key={index}
            active={index === currentIndex}
            onClick={() => goToSlide(index)}
          />
        ))}
      </CarouselIndicators>
    </MarketingCarousel>
  );
};

export default HomeCarousel;
